import { Theme, getInitialTheme } from "themes/helpers";

import { AppAction, AppActionNames } from "./actions";

export interface IAppState {
  loaded: boolean;
  initialReferrer: string;
  theme: Theme;
}

export const initialState = {
  loaded: false,
  initialReferrer: "",
  theme: getInitialTheme(),
};

const appReducer = (state: IAppState = initialState, action: AppAction): IAppState => {
  switch (action.type) {
    case AppActionNames.READY:
      return {
        ...state,
        loaded: true,
      };
    case AppActionNames.SET_INITIAL_REFERRER:
      return {
        ...state,
        initialReferrer: action.payload,
      };
    case AppActionNames.SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
